document.addEventListener("DOMContentLoaded", function () {
  function createBackToTopButton() {
    if (document.querySelector(".back-to-top")) return;

    const btn = document.createElement("button");
    btn.type = "button";
    btn.className = "back-to-top";
    btn.setAttribute("aria-label", "Back to top");
    btn.innerHTML = `
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path d="M2 2.5H14M7.979 13.906V4.957M12.109 8.846L7.98 4.715L3.849 8.845" stroke="white"/>
    </svg>
  `;

    document.body.appendChild(btn);

    const toggleVisibility = () => {
      const shouldShow = window.scrollY > 300;
      btn.classList.toggle("back-to-top--visible", shouldShow);
    };

    window.addEventListener("scroll", toggleVisibility, { passive: true });
    toggleVisibility();

    btn.addEventListener("click", (e) => {
      e.preventDefault();

      const targets = [...document.querySelectorAll(".recommend-module")];
      
      if (targets.length > 0) {
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });
        return;
      }

      const offset = 0;
      const elementTop = target.getBoundingClientRect().top + window.scrollY;
      const finalPosition = elementTop - offset;

      window.scrollTo({
        top: finalPosition,
        behavior: "smooth",
      });
    });
  }
  window.addEventListener("click", (evt) => {
    const link = evt.target.closest(".recommend-link");
    if (!link) return;
    evt.preventDefault();

    const targetOption = link.dataset.destination;
    let target = null;

    switch (targetOption) {
      case "ingredients":
        target =
          document.querySelector(".premium-ingredients") ||
          document.querySelector(".ingredientsDS__wrapper");
        break;

      case "benefits":
        target = document.querySelector(".benefits-section-class");
        break;

      case "reviews":
        target = document.querySelector("#stamped-main-widget");
        break;

      default:
        console.warn("Destino no reconocido:", targetOption);
        return;
    }

    if (!target) return;

    const offset = 120;
    const elementTop = target.getBoundingClientRect().top + window.scrollY;
    const finalPosition = elementTop - offset;

    window.scrollTo({
      top: finalPosition,
      behavior: "smooth",
    });
  });

  createBackToTopButton();
});
